import axios from 'axios'

export default {
    setupInactivity(data) {
        return axios.post('/availability/setup-inactivity', data)
    },

    deleteInactivity(id) {
        return axios.delete(`/availability/delete-inactivity/${id}`)
    },

    getUserAvailabilityInactivity({ take, skip }) {
        return axios.post(`/user-availability/availability-offer-inactivity`, { take, skip })
    },

    getUserCompanyAvailabilityInactivity({ id, take, skip }) {
        return axios.post(
            '/company-availability/availability-offer-inactivity-user',
            { take, skip },
            {
                headers: {
                    'x-tenant-id': id,
                },
            },
        )
    },
    getAdminCompanyAvailabilityInactivity({ id, take, skip }) {
        return axios.post(
            '/company-availability/availability-offer-inactivity-admin',
            { take, skip },
            {
                headers: {
                    'x-tenant-id': id,
                },
            },
        )
    },

    removeAvailability(data) {
        return axios.delete('/availability/delete-availability', { data: data })
    },

    getAvailabilityPerformers(params) {
        const pathParams = params ? `?${params}` : ''
        return axios.get('/availability/performers' + pathParams)
    },
}
